import { Dispatch } from 'redux';
import Service from 'src/setup/network';
import { Expenses, Pagination } from 'src/types/model';
import {
  ExpensesActionType,
  FETCH_EXPENSES_FAILURE,
  FETCH_EXPENSES_REQUEST,
  FETCH_EXPENSES_SUCCESS,
} from '../types/expensesTypes';

export interface FetchExpensesParams {
  from?: string | null;
  to?: string | null;
  categoryId?: string;
  type?: string;
  limit?: number;
  page?: number;
}

export const fetchExpensesRequest = (): ExpensesActionType => ({
  type: FETCH_EXPENSES_REQUEST,
});

export const fetchExpensesSuccess = (
  data: Expenses[],
  pagination: Pagination,
  expensesTotal: number
): ExpensesActionType => ({
  type: FETCH_EXPENSES_SUCCESS,
  payload: { data, pagination, expensesTotal },
});

export const fetchExpensesFailure = (error: string): ExpensesActionType => ({
  type: FETCH_EXPENSES_FAILURE,
  payload: error,
});

export const fetchExpenses = (filters?: FetchExpensesParams) => {
  return async (dispatch: Dispatch<ExpensesActionType>) => {
    dispatch(fetchExpensesRequest());

    try {
      const queryParams = filters
        ? '?' +
          Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(
              ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                  value as string
                )}`
            )
            .join('&')
        : '';

      const response = await Service.get(`/expenses/own${queryParams}`);
      const data: Expenses[] = response?.data?.data?.expenses?.data ?? [];
      const pagination: Pagination =
        response?.data?.data?.expenses?.pagination ?? {};
      const expensesTotal: number = response?.data?.data?.expensesTotal ?? [];
      dispatch(fetchExpensesSuccess(data, pagination, expensesTotal));
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to fetch expenses';
      dispatch(fetchExpensesFailure(errorMsg));
      throw new Error(errorMsg);
    }
  };
};
